import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  cover: string;
  rating: number;
  views: string;
  status: string;
  category: string;
  tags: string[];
}

export default function ComicCard({ id, title, cover, rating, views, status, tags }: ComicCardProps) {
  return (
    <Link to={`/article/${id}`} className="group block" data-product-shop="">
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={cover}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${status === '连载中' ? 'bg-rose-500 text-white' : 'bg-foreground-800 text-white'}`}>
            {status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8">
          <div className="flex items-center gap-2">
            <span className="flex items-center gap-0.5 text-yellow-400 text-xs">
              <i className="ri-star-fill text-xs" />
              {rating}
            </span>
            <span className="text-white/70 text-xs">{views}</span>
          </div>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-rose-500 transition-colors duration-200 line-clamp-1">
        {title}
      </h3>
      <div className="flex items-center gap-2 mt-1 flex-wrap">
        {tags.slice(0, 2).map((tag) => (
          <span key={tag} className="text-xs text-foreground-400 bg-background-100 px-1.5 py-0.5 rounded whitespace-nowrap">
            {tag}
          </span>
        ))}
      </div>
    </Link>
  );
}